/**
 * @generated SignedSource<<a4a89c8c6e7ef6830085f744e9eb76ad>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type SavedViewsShortcutsFragment$data = {
  readonly shortcuts: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly query: string;
      readonly " $fragmentSpreads": FragmentRefs<"SavedViewRow">;
    } | null | undefined> | null | undefined;
    readonly totalCount: number;
  };
  readonly " $fragmentType": "SavedViewsShortcutsFragment";
};
export type SavedViewsShortcutsFragment$key = {
  readonly " $data"?: SavedViewsShortcutsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"SavedViewsShortcutsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SavedViewsShortcutsFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 25
        },
        {
          "kind": "Literal",
          "name": "searchTypes",
          "value": [
            "ISSUES"
          ]
        }
      ],
      "concreteType": "SearchShortcutConnection",
      "kind": "LinkedField",
      "name": "shortcuts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchShortcut",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "query",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SavedViewRow"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "shortcuts(first:25,searchTypes:[\"ISSUES\"])"
    }
  ],
  "type": "UserDashboard",
  "abstractKey": null
};

(node as any).hash = "54b562703acca0689408ea22e5656e42";

export default node;
